import * as React from 'react';
import { withTranslation } from 'react-i18next';

const SurveyStatusComponent = ({ survey, t }) => (
  <div className="SurveyType">{t('survey:survey_type', { context: survey.survey_type })}</div>
);

export default withTranslation()(SurveyStatusComponent);
